import { useEffect, useState, useMemo } from "react";
import apiService from '../../services/apiService';
import '../../styles/pages/dataSets.scss';
import DatasetsCard from "../../components/DatasetsCard";
import DatasetsModal from "../../components/DatasetsModal";
import { InputSwitch } from 'primereact/inputswitch';
import Add from "../../assets/icons/add"
import { InputText } from "primereact/inputtext";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { DateFormatter } from "../../utils/DateFormatter";
import { Link } from "react-router-dom";
import { FilterMatchMode, FilterService } from 'primereact/api';
import { Dropdown } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";

export default function Carousel() {
    // FilterService.register('custom_date', (value, filter) => {
    //     return true;
    //     if (!filter) return true;
    //     return DateFormatter(value).contains(filter);
    // })
    const [dataSetList, setdataSetList] = useState([]);
    const [error, setError] = useState("");
    const [tableView, setTableView] = useState(true);
    const [searchText, setSearchText] = useState('');
    const [loading, setLoading] = useState(true);
    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        name: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
        createdByUsername: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
        createdAt: { value: null, matchMode: FilterMatchMode.DATE_IS},
        updatedAt: { value: null, matchMode: FilterMatchMode.DATE_IS},
        number_of_samples: {value: null, matchMode: FilterMatchMode.EQUALS },
        is_public: { value: null, matchMode: FilterMatchMode.STARTS_WITH }
    });

    useEffect(() => {
        document.title = 'Datasets | Palmona Pathogenomics'
    }, []);

    const getDataUserToken = JSON.parse(sessionStorage.getItem('apitoken'));

    const headers = {
        Authorization: `Bearer ${getDataUserToken}`,
    };

    function getSessionStorageOrDefault(key, defaultValue) {
        const stored =  sessionStorage.getItem(key);
        if (!stored) {
          return defaultValue;
        }
        return JSON.parse(stored);
    }
    const [userid] = useState(
        getSessionStorageOrDefault('userid', null)
    );

    const formatDate = (value) => {
        return value.toLocaleDateString("en-US", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric"
        });
      };

    const dateTemplate = (dataset, prop) => formatDate(dataset[prop]);

    const nameLinkTemplate = dataset => {
        const linkState = {
            id:dataset.id,
            name:dataset.name
        }
        return <Link to="dataset_details" state={linkState}>{dataset.name}</Link>
    }


    const [getDataSet, setGetDataSet] = useState();

    useEffect(() => {
        fetch(process.env.REACT_APP_WORKFLOW_API_PATH + "wfapi/dataset?userId=" + userid, {
            headers
        })
            .then(res => res.json())
            .then((dataList) => {

            // dataList.sort((a, b) => { return new Date(b.createdAt) - new Date(a.createdAt) });
                Promise.all(dataList?.map((data) => 
                    fetch(process.env.REACT_APP_WORKFLOW_API_PATH + `wfapi/datasetdetails/${data.id}?userId=${userid}`, {
                        headers
                    })
                        .then(res => res.json())
                        .then(extra => Object.assign(data, extra))
                        .then(ds => {
                            ds.createdAt = new Date(ds.createdAt);
                            ds.updatedAt = new Date(ds.updatedAt);
                        })
                    ))
                .then(() => setdataSetList(dataList))
                .finally(() => setLoading(false));
                
        }).catch((err) => {
            setError(err.response.status)
        })
    }, []);

    const filteredDataSetList = useMemo(() => {
        return dataSetList.filter(dataset => dataset.name.includes(searchText));
    }, [dataSetList, searchText]);

    const publicDataList = filteredDataSetList.filter(dataset => dataset.is_public);
    const privateDataList = filteredDataSetList.filter(dataset => !dataset.is_public)

    const publicFilterTemplate = (options) => {
        return (
            <Dropdown value={options.value} options={[{value: 'true', label:'Public'}, {value: 'false', label: 'Private'}]} onChange={e => options.filterApplyCallback(e.value)} showClear/>
        )
    }

    const dateFilterTemplate = (options) => {
        return (
            <Calendar 
                value={options.value} 
                onChange={e => options.filterApplyCallback(e.value, options.index)}
                dateFormat="mm/dd/yy"
                placeholder="mm/dd/yyyy"
                mask="99/99/9999"
            />
        )
    }
    

    return (
        <div className="datasets-main">
            <div className="d-flex justify-content-between">
                <div style={{ fontWeight: "500", fontSize: "16px" }}> Dataset Management</div>
                <div>
                    <label>Table View</label>
                    <InputSwitch checked={tableView} onChange={(e) => setTableView(e.value)} />
                </div>
                <div>
                    <InputText type="text" className="search" name="search" placeholder="Search" style={{ padding: "5px" }} value={searchText} onChange={e => setSearchText(e.target.value)}/>
                </div>
                <button className="newdata" data-bs-toggle="modal" data-bs-target="#myModal" style={{ paddingLeft: "0.5rem", fontSize: "15px" }}>
                    <Add color={"#f58220"}/>
                    &nbsp;
                    {/* <a style={{ paddingLeft: "0.5rem" }}>New Data</a> */}
                    New Data
                </button>
            </div>
            <br />
            {!tableView && <div>
                <div style={{ fontWeight: "500", fontSize: "14px" }}>Private Datasets</div>
                <div className="datasets-cont2" >
                    {privateDataList?.length > 0 ?
                        <DatasetsCard content={privateDataList} /> :
                        error || dataSetList.length ? <div className="loading">No Private Datasets found</div> :
                            <div className="loading">
                                <div className="spinner-border" role="status">
                                    <span className="sr-only">Loading...</span>
                                </div>
                            </div>
                    }
                </div>
                <br />
                <div style={{ fontWeight: "500", fontSize: "14px" }}>Public Datasets</div>
                <div className="datasets-cont2" >
                    {publicDataList?.length > 0 ?
                        <DatasetsCard content={publicDataList} /> :
                        error || dataSetList.length ? <div className="loading">No Public Datasets found</div> :
                            <div className="loading">
                                <div className="spinner-border" role="status">
                                    <span className="sr-only">Loading...</span>
                                </div>
                            </div>
                    }
                </div>
            </div>}
            {tableView && <DataTable value={filteredDataSetList} loading={loading} paginator rows={10} rowsPerPageOptions={[5, 10, 25, 50]} filterDisplay='row' filters={filters} globalFilterFields={['name', 'createdBy', 'number_of_samples', 'is_public']}>
                <Column field="name" header="Name" body={nameLinkTemplate} sortable filter/>
                <Column field="createdByUsername" header="Created By" sortable filter/>
                <Column field="createdAt" header="Created At" filterField="createdAt" dataType="date" body={(dataset) => dateTemplate(dataset, 'createdAt')} sortable filter filterElement={dateFilterTemplate}/>
                <Column field="updatedAt" header="Updated At" filterField="updatedAt" dataType="date" body={(dataset) => dateTemplate(dataset, 'updatedAt')} sortable filter filterElement={dateFilterTemplate}/>
                <Column field="number_of_samples" header="No. of Samples" sortable filter/>
                <Column field="is_public" header="Visibility" body={(dataset) => dataset.is_public ? 'Public' : 'Private'} sortable filter showFilterMenu={false} filterElement={publicFilterTemplate}/>
                {/* <Column header="Details" body={detailsLinkTemplate}/> */}
            </DataTable>}
            <DatasetsModal  getDataSet={getDataSet}/>
             
            {/* {modal && <DatasetsModal  getDataSet={setSetDataSet(true)}/>} */}

        </div>
    );
}